<template>
  <b-modal ref="mc-modal" size="md" centered scrollable :title="$t('delivery.action.selectUserGroup')">
    <div class="card-body p-2">
      <p class="mb-2" v-html="selectUserGroupForStatusesMessage"></p>
      <p>{{ $t('delivery.message.allDeliveriesAssignedToSameUserGroup') }}</p>

      <FormulateForm
        v-model="formValues"
        name="user-group-form"
        @submit="handleSubmit"
        @failed-validation="handleFailedValidation"
      >
        <FormulateInput
          type="value-help-v2"
          name="user_group_id"
          :label="$t('delivery.fields.userGroup')"
          trackBy="id"
          validation="required"
          :placeholder="$t('delivery.action.selectUserGroup')"
          displayedBy="name"
          :help="true"
          :listGetter="listUserGroup"
          :fullObject="fullObject"
          :tableFields="tableFields"
          :validation-messages="{
            required: $t('global.validation.required')
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton variant="secondary" :text="$t('global.back')" @click="cancel" />
        <McButton :text="$t('global.apply')" :disabled="disabled" @click="triggerSubmit" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import * as Reason from '@/services/rest-api/lib/delivery/reason'
import McButton from '@/components/McButton'

import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'

export default {
  components: {
    McButton,
  },
  props: {},
  emits: ['transition'],
  data() {
    return {
      formValues: {},
      reasonGet: Reason.get("type eq 'CANCELED'"),
      disabled: true,
      fullObject: {},
    }
  },
  computed: {
    selectUserGroupForStatusesMessage() {
      return this.$t('delivery.message.selectUserGroupForStatuses', {
        draft: `<strong>${this.$t('delivery.status.draft')}</strong>`,
        scheduled: `<strong>${this.$t('delivery.status.scheduled')}</strong>`,
      })
    },
    tableFields() {
      return [
        {
          label: this.$t('delivery.fields.userGroup'),
          key: 'name',
          isSortable: false,
        },
        {
          label: this.$t('delivery.fields.vehicleGroup'),
          key: 'vgroups',
          isSortable: false,
          formatter: (value) => {
            return value?.length != null
              ? value.length === 0
                ? this.$t('delivery.text.allVehicleGroup')
                : value.length
              : '-'
          },
        },
      ]
    },
  },
  watch: {
    formValues: {
      handler() {
        const reasonId = this.formValues['user_group_id']

        this.disabled = reasonId === null || reasonId === undefined
      },
      deep: true,
    },
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('user-group-form')
    },
    handleSubmit(data) {
      this.$emit('change-user-group', {
        user_group_id: parseInt(data['user_group_id']),
      })
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    show() {
      this.$refs['mc-modal'].show()
    },
    hide() {
      this.$refs['mc-modal'].hide()
    },
    async listUserGroup(opts) {
      let result = {}
      const filter = {
        pagination: {
          page: opts?.page,
          show: opts?.limit,
        },
        search: opts?.search,
      }

      const res = await this.$apollo.query({
        query: GET_USER_GROUP,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
          },
        },
      })

      const ugroups = res.data.ugroups.ugroups

      result = {
        metadata: {
          total_count: ugroups.pagination.total,
          page: ugroups.pagination.page,
        },
        data: {
          paginated_result: ugroups.data,
        },
      }

      return result
    },
  },
}
</script>

<style>
.__transition-icon {
  font-size: 20px;
  vertical-align: middle;
  margin: 0 10px;

  &::before {
    color: #4a90e1;
  }
}

strong {
  font-weight: 600;
}
</style>
